var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckboxNull = function SvgIconCheckboxNull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-checkbox-null_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEE1EB",
    d: "M19.286 0H.714A.714.714 0 0 0 0 .714v18.572c0 .394.32.714.714.714h18.572c.394 0 .714-.32.714-.714V.714A.714.714 0 0 0 19.286 0m-.715 15.571a3 3 0 0 1-3 3H4.43a3 3 0 0 1-3-3V4.43a3 3 0 0 1 3-3H15.57a3 3 0 0 1 3 3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-checkbox-null_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    rx: 5
  })))));
};
export default SvgIconCheckboxNull;